import React from 'react';
import styled from 'styled-components';

const FooterContainer = styled.footer`
  background-color: #000;
  color: white;
  padding: 3rem 6%;
`;

const FooterText = styled.p`
  color: #ccc;
  text-align: center;
`;

const FooterLinks = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 1.5rem;
`;

const FooterLink = styled.a`
  color: #ccc;
  margin: 0 1rem;
  transition: all 0.3s ease;
  text-decoration: none;
  position: relative;
  
  &:after {
    content: '';
    position: absolute;
    bottom: -5px;
    left: 0;
    width: 0;
    height: 1px;
    background-color: white;
    transition: width 0.3s ease;
  }
  
  &:hover {
    color: white;
    
    &:after {
      width: 100%;
    }
  }
`;

const Logo = styled.div`
  font-size: 1.5rem;
  font-weight: 800;
  color: white;
  margin-bottom: 2rem;
  text-align: center;
  
  span {
    font-weight: 400;
  }
`;

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <FooterContainer>
      <Logo>Legal<span>HDM</span></Logo>
      <FooterLinks>
        <FooterLink href="#">Legal Information</FooterLink>
        <FooterLink href="#">Contact</FooterLink>
      </FooterLinks>
      <FooterText>
        © Copyrights LegalHDM {currentYear}
      </FooterText>
    </FooterContainer>
  );
};

export default Footer; 